import React, {useState} from 'react'
import { useDispatch } from 'react-redux'
import styled, { keyframes } from 'styled-components'

const ShareModal = () => {
    return(<div>ok</div>)
}

export default ShareModal